<template>
    <div class="mt-2  mt-sm-0 ml-4  ml-sm-0 mr-0  py-0
        text-xl-subtitle-1 text-lg-body-2 text-md-body-2">
        <a :href="'mailto:'+researcher.email">
            <p class="pt-1 pb-0 my-0 orange--text ">E-mail:&nbsp;
                <span class="white--text">{{researcher.email}}</span>
            </p>
        </a>
        <p v-if="researcher.telephone" class="pt-1 pb-0 my-0 orange--text">Tel.:&nbsp;
            <span class="white--text ">{{researcher.telephone}}</span>
        </p>
        <p v-if="researcher.office" class="pt-1 pb-0 my-0 orange--text">Office:&nbsp;
            <span class="white--text ">{{researcher.office}}</span>
        </p>
    </div>
</template>
<script>
export default {
  props:['researcher'],
}
</script>
